import { Route } from "react-router-dom";

import { AppReportTemplate2 } from "src/components/admin/AppReportTemplate2";
import { ADMIN_ROUTES } from "src/pages/admin/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { ViewAllNotification } from "./notification/ViewAllNotification";
import { ConnectedPlanList as PlanList } from "./plan/PlanList";

/** Miscellaneous admin routes: notifications, plan list and the print template. */
export const adminRoutes = (
  <>
    <Route path={ADMIN_ROUTES.notification} element={<ProtectedRoute component={ViewAllNotification} />} />
    <Route path={ADMIN_ROUTES.plans} element={<ProtectedRoute component={PlanList} />} />
    <Route path={ADMIN_ROUTES.print} element={<ProtectedRoute component={AppReportTemplate2} />} />
  </>
);
